import {take, fork, cancel} from 'redux-saga/effects';
import {LOCATION_CHANGE, matchPath, parseSearchQueryParams} from '@computerrock/formation-router';
import routePaths from '../../routePaths';
import samaScreenTabs from '../samaScreenTabs';
import * as samaActionTypes from '../samaActionTypes';
import onSAMAMapClickSelectDoctorLocation from './onSAMAMapClickSelectDoctorLocation';

const samaMapDoctorLocationWatcher = function* samaMapDoctorLocationWatcher() {
    mainFlow: while (true) {
        const {payload} = yield take(samaActionTypes.START_SAMA_MAP_DOCTOR_LOCATION_WATCHER);

        const onSAMAMapClickSelectDoctorLocationTask = yield fork(
            onSAMAMapClickSelectDoctorLocation,
            payload,
        );

        while (true) {
            const watcherTerminationAction = yield take([
                samaActionTypes.STOP_SAMA_MAP_DOCTOR_LOCATION_WATCHER,
                LOCATION_CHANGE,
            ]);

            if (watcherTerminationAction.type === samaActionTypes.STOP_SAMA_MAP_DOCTOR_LOCATION_WATCHER) {
                yield cancel(onSAMAMapClickSelectDoctorLocationTask);
                continue mainFlow;
            }

            const {payload} = watcherTerminationAction;
            const {location} = payload;

            const samaRouteMatch = matchPath(location.pathname, {
                path: routePaths.SERVICE_ASSIGNMENT_MEDICAL_ADVICE,
                exact: true,
            });

            const {activeTab} = samaRouteMatch ? parseSearchQueryParams(location.search) : {};
            if (!samaRouteMatch || activeTab !== samaScreenTabs.SERVICE_PROVIDER) {
                yield cancel(onSAMAMapClickSelectDoctorLocationTask);
                continue mainFlow;
            }
        }
    }
};

export default samaMapDoctorLocationWatcher;
